/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_PayboxInputs */

const en_method_paybox = /** @type {(inputs: Method_PayboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`paybox`)
};

const he_method_paybox = /** @type {(inputs: Method_PayboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פייבוקס`)
};

/**
* | output |
* | --- |
* | "paybox" |
*
* @param {Method_PayboxInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_paybox = /** @type {((inputs?: Method_PayboxInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_PayboxInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_paybox(inputs)
	return he_method_paybox(inputs)
});